$(() => {
  let speed = 7000;
  if (typeof CAROUSEL_SPEED !== 'undefined') {
    speed = CAROUSEL_SPEED * 1000;
  }

  const pauseLabel = django.gettext('Keskeytä');
  const playLabel = django.gettext('Käynnistä');

  $(".flexslider").flexslider({
    controlNav: true,
    directionNav: true,
    slideshowSpeed: speed,
    nextText: "",
    prevText: "",
    touch: true,
    pausePlay: true,
    pauseText: `<i class="fa fa-pause" aria-hidden="true"></i>`,
    playText: `<i class="fa fa-play" aria-hidden="true"></i>`, 
    start: function() { // The start option is triggered when the slider has completed its initial setup

      $('.flex-play').attr({'tabindex': '0', 'aria-label': playLabel});
      $('.flex-play').on('keyup', e => {
        if (e.key === 'Enter') {
          $(e.target).click();
        }
      });

      $('.flex-pause').attr({'tabindex': '0', 'aria-label': pauseLabel});
      $('.flex-pause').on('keyup', e => {
        if (e.key === 'Enter') {
          $(e.target).click();
        }
      });
    },
  });
});
